<template>
    <div class="collectClassify classifyBase">
        <div class="borderLine borderTop title color666">征集送拍</div>
        <div class="borderLine list">
            <ul>
                <li v-for="(item) in dataList" :key="item.id" :class="{'isActive':item.id==select}" @click="itemClick(item.id)">
                    <a class="item">
                        <strong class="auctionFont color333 yahei">{{item.name}}</strong>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "collectClassify",
    data(){
        return{
            dataList:[
                {id:1,name:"拍卖征集"},
                {id:2,name:"拍品送拍"},
            ],
            select:this.$route.query.id || 1
        }
    },
    methods:{
        itemClick(id){
            this.$emit('itemClick',id)
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
</style>